/* Unhinged auto "This Week" cards — reads the public Google Calendar.
   Lives in the THEME (assets/unhinged-events.js), loaded only on /pages/event-calendar
   via a conditional in theme.liquid, so the Shopify page editor can never strip it.
   If the API fails, the hand-written cards in the page body stay as-is. */
(function () {
  var KEY = 'AIzaSyAvhiM7f79eKb-Xo3zuzHX_VbxmcYUDyq4';
  var CAL = 'c_112b890135967dbc4eff27369174de321bcae0d616ddf4d18e6c9e176f7ef206@group.calendar.google.com';
  var TZ = 'America/Denver';
  if (!document.getElementById('uhe-cards-root')) return; // not the events page

  function denverYMD(d) {
    return new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  }
  function denverParts(d) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: TZ, weekday: 'long', month: 'short', day: 'numeric' });
    var parts = {};
    f.formatToParts(d).forEach(function (x) { parts[x.type] = x.value; });
    return parts;
  }
  function fmtTime(d) {
    return new Intl.DateTimeFormat('en-US', { timeZone: TZ, hour: 'numeric', minute: '2-digit' }).format(d).replace(':00', '');
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function cleanDesc(s) {
    if (!s) return '';
    var t = String(s).replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim();
    if (t.length > 140) {
      t = t.slice(0, 140);
      var cut = t.lastIndexOf(' ');
      if (cut > 80) t = t.slice(0, cut);
      t += '…';
    }
    return t;
  }

  var now = new Date();
  var todayKey = denverYMD(now);
  var tMin = new Date(now.getTime() - 12 * 3600 * 1000).toISOString();
  var tMax = new Date(now.getTime() + 8 * 86400 * 1000).toISOString();
  var url = 'https://www.googleapis.com/calendar/v3/calendars/' + encodeURIComponent(CAL) +
    '/events?key=' + KEY + '&singleEvents=true&orderBy=startTime&maxResults=100' +
    '&timeMin=' + encodeURIComponent(tMin) + '&timeMax=' + encodeURIComponent(tMax);

  fetch(url).then(function (r) { return r.json(); }).then(function (data) {
    if (!data.items) return;
    var days = {};
    data.items.forEach(function (ev) {
      if (ev.status === 'cancelled') return;
      var title = (ev.summary || '').trim();
      if (!title || /cancell?ed/i.test(title)) return;
      var allDay = !ev.start.dateTime;
      var start = allDay ? new Date(ev.start.date + 'T12:00:00-06:00') : new Date(ev.start.dateTime);
      var key = allDay ? ev.start.date : denverYMD(start);
      if (key < todayKey) return;
      if (!days[key]) days[key] = { date: start, events: [], specials: [] };
      var isSpecial = (/^\$|\$\d|\bOFF\b/i.test(title)) && allDay;
      if (isSpecial) days[key].specials.push(title);
      else days[key].events.push({ title: title, allDay: allDay, start: start, desc: cleanDesc(ev.description) });
    });

    var keys = Object.keys(days).sort().slice(0, 7);
    var cards = '';
    var count = 0;
    keys.forEach(function (k) {
      if (count >= 7) return;
      var d = days[k];
      var headline, time, music = false, desc = '';
      if (d.events.length) {
        var e = d.events[0];
        headline = e.title;
        desc = e.desc;
        music = /live music|unplug|band|karaoke|dj\b|cumbia|acoustic|fest/i.test(e.title);
        time = e.allDay ? 'All Day' : (music ? 'Live Music &middot; ' : '') + fmtTime(e.start);
      } else if (d.specials.length) {
        headline = d.specials[0];
        time = 'All Day';
      } else { return; }
      var parts = denverParts(d.date);
      var tonight = (k === todayKey);
      var extra = d.events.length > 1 ? ('Plus: ' + esc(d.events.slice(1).map(function (x) { return x.title; }).join(', '))) : '';
      if (desc) extra = esc(desc) + (extra ? ' &middot; ' + extra : '');
      var tag = d.specials.length && d.events.length ? esc(d.specials.join(' + ')) : (music ? 'No cover &mdash; grab a pint' : '');
      cards += '<div class="uhe-card' + (tonight ? ' uhe-card--tonight' : '') + (music ? ' uhe-card--music' : '') + '">' +
        (tonight ? '<span class="uhe-badge">Tonight</span>' : '') +
        '<div class="uhe-day">' + parts.weekday + ' <small>' + parts.month + ' ' + parts.day + '</small></div>' +
        '<div class="uhe-ev">' + esc(headline) + '</div>' +
        '<div class="uhe-time">' + time + '</div>' +
        (extra ? '<p class="uhe-note">' + extra + '</p>' : '') +
        (tag ? '<div class="uhe-tag">' + tag + '</div>' : '') +
        '</div>';
      count++;
    });

    if (count >= 3) {
      document.getElementById('uhe-cards-root').innerHTML = cards;
      var first = denverParts(days[keys[0]].date);
      var last = denverParts(days[keys[keys.length - 1]].date);
      document.getElementById('uhe-week-range').innerHTML = first.month + ' ' + first.day + ' &ndash; ' +
        (first.month === last.month ? '' : last.month + ' ') + last.day;
    }
  }).catch(function () {});
})();